import PersonalOfferPDPLoader from './PersonalOfferPDPLoader'

export { PersonalOfferPDPLoader }

export default PersonalOfferPDPLoader
